// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NE5Ep"};